import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FileUploadType } from '../../../api/models/file-uploaded';

@Component({
  selector: 'app-import-export',
  templateUrl: './import-export.component.html',
  styleUrls: ['./import-export.component.scss']
})
export class ImportExportComponent implements OnInit {

  @Input() worksheetId: string;
  @Input() exportDisable: boolean;

  fileExtension = FileUploadType.CSV;

  constructor(
    public activeModal: NgbActiveModal
  ) { }

  ngOnInit() {
    //Empty ngOnInit method
  }

  saveEvent($event) {
    this.activeModal.close($event);
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/order-worksheet/import-export/import-export.component.ts